module.exports = __webpack_public_path__ + "img/expired.c89c6431.png";